import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Layout from "../components/Layout";
import SEO from "../components/Seo";
import DefaultBanner from "../components/DefaultBanner";
import { useServices } from "utils/requests";
import ServicesCard from "components/ServicesCard";


const Applications = () => {
  const { id } = useParams();
  const { isError, isLoading, isSuccess, data: stacResponse } = useServices();
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    if (isSuccess) {
      const service = stacResponse.features;
      if (service) {
        setApplications(stacResponse.features)
      } else {
      }
    }
  }, [id, stacResponse, isSuccess]);


  const banner = (
    <DefaultBanner>
      <h1>Edge Services</h1>
      <p>Edge Services access requires governance board approval based on eligibility criteria.<br />Follow the <a href="https://destine-data-lake-docs.data.destination-earth.eu/en/latest/dedl-big-data-processing-services/Access-BDP-services/Access-BDP-services.html">Access DestinE Edge Services</a> instructions to request access.</p>
    </DefaultBanner>
  );


  const appsList = applications.map(app => {
    return <ServicesCard key={`card-${app.id}`} app={app} />;
  });


  return (
    <Layout bannerHeader={banner} isShort>
      <SEO title="Edge Services" />
      <div className="layout-container">
        <div className="layout-row grid-content">{appsList}</div>
      </div>
    </Layout>
  );
};

export default Applications;
